import { shade } from 'polished';
import styled, { css } from 'styled-components';

const detectBrowser = () => {
  const userAgent = navigator.userAgent;

  if (userAgent.includes('Chrome')) {
    return 'chrome';
  } else if (userAgent.includes('Firefox')) {
    return 'firefox';
  } else if (userAgent.includes('Safari')) {
    return 'safari';
  } else {
    return 'other'; // Para outros navegadores
  }
};

const getScrollbarStyles = (browser: string) => {
  if (browser !== 'firefox') {
    return css`
      /* Estilizando o Scrollbar para Chrome/Safari */
      &::-webkit-scrollbar {
        width: 5px;
        height: 5px; /* Para barras de rolagem horizontais */
      }

      &::-webkit-scrollbar-thumb {
        cursor: pointer;
        background-color: ${props =>
          props.theme.secundaria}; /* Cor do "thumb" */
        border-radius: 10px;
        border: 3px solid transparent;
      }

      &::-webkit-scrollbar-track {
        background-color: #f0f0f0; /* Cor do "track" */
        margin-bottom: 5px;
      }

      /* Remove as setas do scrollbar em WebKit */
      &::-webkit-scrollbar-button {
        display: none; /* Remove as setas do scrollbar */
      }
    `;
  } else {
    return css`
      /* Estilizando o Scrollbar para Firefox */
      scrollbar-width: thin; /* Largura do scrollbar: "auto" ou "thin" */
      scrollbar-color: ${props => props.theme.secundaria} #f0f0f0; /* Cor do thumb e do track */
    `;
  }
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 95%;

  h1 {
    color: ${props => props.theme.secundaria};
  }
`;

export const NotificacoesContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 10px;

  margin-top: 15px;

  overflow-y: auto;
  ${getScrollbarStyles(detectBrowser())};
`;

export const NotificacoesCard = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  min-height: 60px;

  cursor: default;

  border: 1px solid ${props => props.theme.secundaria};
  border-left: 5px solid ${props => props.theme.secundaria};

  padding: 5px;

  div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    gap: 5px;

    span {
      font-weight: bold;
    }
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;

  margin: 0px 5px 5px 0px;
  border: 1px solid #ccc;

  border-radius: 8px;
  border: 1.5px solid ${props => props.theme.secundaria};
`;

export const SectionTitle = styled.h3`
  font-weight: bold;
  color: ${props => props.theme.secundaria};

  margin-bottom: 10px;
`;

export const LidaButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;

  margin-left: 10px;

  height: 30px;
  width: 30px;

  border: none;
  border-radius: 100%;
  background: ${props => props.theme.secundaria};

  svg {
    color: white;
  }

  &:hover {
    background: ${props => shade(0.4, props.theme.secundaria)};
  }
`;
